import styled from "styled-components";
import { useState } from "react";
import { GoSun, GoMoon } from "react-icons/go";
const SliderSwitch = ({ theme, toggleTheme, light, dark }) => {
  const [isChecked, setIsChecked] = useState(() =>
    theme === light ? true : false
  );
  return (
    <Wrapper>
      <label aria-label="toggle dark and light mode" className="switch">
        <input
          onChange={() => {
            setIsChecked((prev) => !prev);
            toggleTheme();
          }}
          checked={isChecked}
          type="checkbox"
        />

        <span className="slider round">
          <div className="icons">
            <GoSun className="icon" />
            <GoMoon className="icon" />
          </div>
        </span>
      </label>
    </Wrapper>
  );
};

export default SliderSwitch;

const Wrapper = styled.div`
  position: absolute;
  right: 1.5rem;
  top: 22.5vh;
  transform: translateY(-50%);
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 60px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: var(--grey-600);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: ${({ theme }) =>
      theme.colors.sliderSwitchColor}; // switch
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--grey-500); // container
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    -webkit-transform: translateY(-26px);
    -ms-transform: translateY(-26px);
    transform: translateY(-26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .switch .icons {
    display: grid;
    grid-template-columns: 1fr;
    align-content: space-around;
    align-items: center;
    height: 100%;

    .icon {
      justify-self: center;
      color: #fdff87;
    }
  }
`;
